<mat-toolbar color="accent">{{ titleLabel }} Status: Unconfirmed</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <pr-information-box theme="warn">
      The connection timed out before a response was received. As a result, the
      final status of this {{ data.operationLabel }} is currently unknown.
    </pr-information-box>

    <div class="flex flex-col gap-1">
      <span class="font-bold">What to do next:</span>
      <ul class="m-0 flex flex-col gap-1 pl-6">
        <li>
          <span class="font-medium">Verify: </span>
          <span>
            Check your Tyro terminal logs or contact the health fund to confirm
            whether the {{ data.operationLabel }} was successful.
          </span>
        </li>
        <li>
          <span class="font-medium">Reconcile: </span>
          <span>
            A pending transaction has been added to help you track this.
          </span>
        </li>
        <li>
          <span class="font-medium">Finalise: </span>
          <span>
            Once you have confirmed the status, manually update the pending
            entry in the patient's record to match the confirmed outcome.
          </span>
        </li>
      </ul>
    </div>

    <div class="flex flex-col gap-1 text-sm">
      <div class="flex gap-2">
        <span class="w-28 shrink-0 font-medium opacity-70">Code</span>
        <span>{{ data.errorCode }}</span>
      </div>
      <div class="flex gap-2">
        <span class="w-28 shrink-0 font-medium opacity-70">Ref Tag</span>
        <span>{{ data.refTag }}</span>
      </div>
      <div class="flex gap-2">
        <span class="w-28 shrink-0 font-medium opacity-70">Description</span>
        <span>{{ data.errorDescription }}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close color="primary">Close</button>
  </pt-buttons-container>
</mat-dialog-actions>
